import { useMemo } from 'react';

import { convertTimeLetter, formatTimeEvent } from '@helpers';
import type { DashboardResult } from '@api/domain/types';

import { getDashboardResultName } from '@v2/pages/dashboard/common/helpers';
import { DashboardListBarVariant } from '@v2/pages/dashboard/common/components/DashboardList/components/DashboardListBar/types';

export interface UseManageDashboardListDivergingRowParams {
  item: DashboardResult;
}

export const useManageDashboardListDivergingRow = ({ item }: UseManageDashboardListDivergingRowParams) => {
  const seconds = item.totalTimeTotalInSeconds ?? 0;
  const isNegative = seconds < 0;

  const valueText = useMemo(
    () => (isNegative ? '-' : '') + formatTimeEvent(convertTimeLetter(Math.abs(seconds)), false, false).trim(),
    [isNegative, seconds]
  );

  const variant = isNegative ? DashboardListBarVariant.Loss : DashboardListBarVariant.Gain;

  const name = useMemo(() => getDashboardResultName(item), [item]);

  return { seconds, isNegative, valueText, variant, name };
};
